import React, { useEffect, useState } from 'react';
import { Input, Button } from 'antd';
import { ASSET_TYPE } from '@src/components/scene/react-three-components/sceneAsset';

export function AddTwitch({ selectedModel, callBack, items }) {
  const prefix = 'https://twitch.tv/';
  const [url, setURL] = useState<string>(prefix);

  useEffect(() => {
    if (selectedModel?.props?.asset?.metadata?.url) {
      setURL(selectedModel.props.asset.metadata.url);
    } else {
      setURL(prefix);
    }
  }, [selectedModel, prefix]);

  const onChangeStreamURL = (e) => {
    let value = e.target.value;

    if (value.startsWith('http') || value.includes('twitch.tv')) {
      setURL(value);
    } else {
      setURL(prefix + value);
    }
  };

  const handleAddStream = () => {
    if (url && url !== prefix) {
      callBack({
        type: ASSET_TYPE.PRIMITIVE_TEXTURE.STREAM,
        name: items[0].name,
        metadata: {
          type: 'twitch',
          url: url,
        },
      });
    }
  };

  return (
    <>
      <p>Twitch Channel URL</p>
      <Input
        onChange={onChangeStreamURL}
        value={url}
        placeholder='Enter Twitch channel URL'
      />

      <Button
        type='primary'
        style={{
          minHeight: 32,
          marginTop: 10,
        }}
        onClick={handleAddStream}
        disabled={!url || url === prefix}
      >
        Add Twitch Stream
      </Button>
    </>
  );
}
